import * as React from "react";
import { useTranslation } from "react-i18next";
import DynamicForm from "../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../ui/helpers/validators";
import LeftLabelFieldTemplate from "../../../../../ui/templates/fields/LeftLabelFieldTemplate";
import TopLabelFieldTemplate from "../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../../../ui/widgets/custom/buttons/PrwcBasicButton";

const ShiftCode = (props: any) => {
  const { data } = props;
  const { t } = useTranslation();
  const submitButtonRef: any = React.useRef(null);
  const [formData, setFormData] = React.useState(data);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    submitButtonRef.current.click();
  };

  const formButtons = () => {
    return (
      <button ref={submitButtonRef} type="submit" className="hidden p-col-12" />
    );
  };

  const schema: any = {
    title: t("shiftDetails.label.general"),
    type: "object",
    properties: {
      shiftCode: {
        type: "string",
        title: t("shiftDetails.label.shiftCode"),
      },
      shiftName: {
        type: "string",
        title: t("shiftDetails.label.shiftName"),
      },
      abbreviation: {
        type: "string",
        title: t("shiftDetails.label.abbreviation"),
      },
      shiftCodeType: {
        type: "string",
        title: t("shiftDetails.label.shiftCodeType"),
      },
      description: {
        type: "string",
        title: t("shiftDetails.label.description"),
      },
      applyToRoster: {
        type: "string",
        title: t("shiftDetails.label.applyToRoster"),
      },
    },
    required: ["shiftCode", "shiftName", "shiftCodeType"],
  };

  const validationSchema: any = {
    shiftCode: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "shiftDetails.validation.shiftCodeRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 3);
          },
          messageKey: "shiftDetails.validation.shiftCodeMaxLength",
        },
      ],
    },
    shiftName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "shiftDetails.validation.shiftCodeNameRequired",
        },
      ],
    },
    abbreviation: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 15);
          },
          messageKey: "shiftDetails.validation.abbreviationMaxLength",
        },
      ],
    },
    shiftCodeType: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "shiftDetails.validation.shiftCodeTypeRequired",
        },
      ],
    },
    description: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 100);
          },
          messageKey: "shiftDetails.validation.descriptionMaxLength",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    shiftCode: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-3",
      "ui:emptyValue": "",
    },
    shiftName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-9",
      "ui:emptyValue": "",
    },
    abbreviation: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    shiftCodeType: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    description: {
      "ui:widget": "prwInputTextArea",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    applyToRoster: {
      "ui:widget": "prwToggleButton",
      "ui:FieldTemplate": LeftLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
  };

  return (
    <div className="group">
      <div className="px-4 overflow-y-auto content-height">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="users.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default ShiftCode;
